
class HideNoNumber {
  // 1. describe and create/initiate our object
  constructor() {
    this.hideLiClass = document.querySelectorAll(".hide-li");
    this.events()
  }

  // 2. events
  events() {
    if (this.hideLiClass) {
      this.hideLiClass.forEach(item => this.hideGrandparent(item));
    }
  }

  // 3. methods (function, action...)

  hideGrandparent(item) {
    item.parentElement.parentElement.classList.add("hide");
  }
  
}

export default HideNoNumber
